import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { List, SignOut } from "@phosphor-icons/react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = React.useState(false);

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  const dashboardPath = user?.role === "cardholder" ? "/my-cards" : "/";
  // Logged-in cardholders → their dashboard; everyone else → login.
  const myCardPath = user?.role === "cardholder" ? "/my-cards" : "/cardholder/login";

  const links = [
    { to: "/", label: "Home" },
    { to: "/lookup", label: "Lookup" },
    { to: myCardPath, label: "My Card" },
    { to: "/twin-matrix", label: "Twin Matrix" },
  ];

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-black" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" data-testid="brand-logo">
          <img
            src="/curb-crew-logo.svg"
            alt="Curb Crew"
            className="h-10 w-auto"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `label-tag pb-1 border-b-2 ${isActive ? "border-black" : "border-transparent"} hover:border-black`
              }
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user && user.role ? (
            <>
              <Link
                to={dashboardPath}
                className="label-tag px-4 py-2 bg-black text-white brutal-btn"
                data-testid="nav-dashboard"
              >
                Dashboard
              </Link>
              <button
                onClick={handleLogout}
                className="label-tag px-4 py-2 border border-black brutal-btn flex items-center gap-2"
                data-testid="nav-logout"
              >
                <SignOut size={14} weight="bold" /> Logout
              </button>
            </>
          ) : (
            <Link to="/cardholder/login" className="label-tag px-4 py-2 border border-black brutal-btn" data-testid="nav-login">
              Log in
            </Link>
          )}
        </div>

        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          <List size={28} weight="bold" />
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black bg-white px-4 py-4 space-y-3" data-testid="mobile-menu">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="block label-tag py-2"
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </Link>
          ))}
          {user && user.role ? (
            <>
              <Link to={dashboardPath}
                className="block label-tag py-2 bg-black text-white text-center" onClick={() => setOpen(false)}
                data-testid="mobile-nav-dashboard">Dashboard</Link>
              <button onClick={() => { setOpen(false); handleLogout(); }}
                className="block label-tag py-2 w-full border border-black"
                data-testid="mobile-nav-logout">Logout</button>
            </>
          ) : (
            <Link to="/cardholder/login" className="block label-tag py-2 border border-black text-center" onClick={() => setOpen(false)} data-testid="mobile-nav-login">Log in</Link>
          )}
        </div>
      )}
    </header>
  );
}
